<div class="company-search-container">
  <div class="company-search-header">
    <span>Top Firm Searches</span>
  </div>
  <div class="company-search-item-container">
    <div class="company-search-subheader">Last 7 days</div>
    <div class="company-search-item" *ngFor="let result of last7">
      <div (click)="companySearch(result)">{{result}}</div>
    </div>
  </div>
  <div class="company-search-item-container">
    <div class="company-search-subheader">Last 30 days</div>
    <div class="company-search-item" *ngFor="let result of last30">
      <div (click)="companySearch(result)">{{result}}</div>
    </div>
  </div>
  <div class="company-search-item-container">
    <div class="company-search-subheader">All Time</div>
    <div class="company-search-item" *ngFor="let result of allTime">
      <div (click)="companySearch(result)">{{result}}</div>
    </div>
  </div>
</div>
